import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import ArticleCard from "@/components/ArticleCard";
import api from "@/lib/api";

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [search, setSearch] = useState(query);
  const [articles, setArticles] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query) return;
    setLoading(true);
    api.get(`/search?q=${encodeURIComponent(query)}`).then(res => {
      setArticles(res.data.results || []);
      setTotal(res.data.total || 0);
    }).catch(console.error).finally(() => setLoading(false));
  }, [query]);

  const handleSubmit = (e) => { e.preventDefault(); if (search.trim()) setSearchParams({ q: search.trim() }); };

  return (
    <>
      <Helmet>
        <title>{query ? `Recherche : ${query} - OFALycée` : "Recherche - OFALycée"}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="search-page">
        <h1 className="font-heading text-4xl md:text-5xl mb-8">Recherche</h1>
        <form onSubmit={handleSubmit} className="flex gap-3 mb-12 max-w-xl" data-testid="search-form">
          <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Rechercher un article..."
            className="border-b border-input bg-transparent px-0 rounded-none focus-visible:ring-0 text-lg" data-testid="search-input-page" />
          <Button type="submit" className="rounded-none px-6" data-testid="search-submit"><Search className="h-4 w-4" /></Button>
        </form>
        {query && <p className="text-muted-foreground mb-8">{total} resultat{total > 1 ? 's' : ''} pour &laquo; {query} &raquo;</p>}
        {loading ? (
          <div className="space-y-8">{[1,2,3].map(i => <div key={i} className="animate-pulse h-32 bg-muted" />)}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
            {articles.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        )}
      </div>
    </>
  );
}
